import { useLocation, useNavigate } from "react-router";
import Sitemap from "../../config/sitemap.json";
import { NavLink } from "react-router-dom";
import logoCristinaNuovo from "../../assets/logoCristinaNuovo.png";

export const HeaderMobile = () => {
    const location = useLocation();
    const nav = useNavigate();
    return (
        <div className="d-flex justify-content-between align-items-center">
            <div className={location.pathname == "/" ? "bg-none height-0" : "bgCream"}>
                <NavLink to="/">
                    <img className="logo-header" src={logoCristinaNuovo} alt="DoulaCristina" />
                </NavLink>
            </div>
            <span
                className={`d-flex justify-content-end cursor-pointer relative ${
                    location.pathname == "/" ? "bg-none height-0" : "bgCream"
                }`}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    fill="#0088A3"
                    className="bi bi-list m-2"
                    viewBox="0 0 16 16"
                >
                    <path
                        fill-rule="evenodd"
                        d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                    />
                </svg>
            </span>
            <div
                className="offcanvas offcanvas-end"
                tabindex="-1"
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
            >
                <div className="offcanvas-header ms-2">
                    <h5 className="offcanvas-title textBlue" id="offcanvasRightLabel">
                        Menu
                    </h5>
                </div>
                <div className="offcanvas-body d-flex  justify-content-evenly flex-column py-3 ms-2">
                    {Sitemap.map((el) => {
                        return (
                            <span
                                className="textBlue fs-4 underline-none bnt-close"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                                onClick={() => nav(el.link)}
                            >
                                {el.name}
                            </span>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
